var _ellipse, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMetamask(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 91,
    viewBox: "0 0 92 91",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 46.0003,
    cy: 45.0778,
    rx: 45.639,
    ry: 45.0778,
    fill: "#F6851B",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M65.597 25L48.6465 37.5767L51.7949 30.1566L65.597 25Z",
    fill: "#E2761B",
    stroke: "#E2761B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5059 25L43.3032 37.6959L40.3079 30.1566L26.5059 25Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M59.505 54.1528L54.9951 61.0624L64.6447 63.7173L67.4017 54.306L59.505 54.1528Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7188 54.306L27.4587 63.7173L37.1083 61.0624L32.6154 54.1528L24.7188 54.306Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5805 42.478L33.8916 46.5455L43.4561 46.9709L43.1327 36.6747L36.5805 42.478Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M55.522 42.4781L48.8677 36.5557L48.6465 46.971L58.2109 46.5456L55.522 42.4781Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1084 61.0623L42.8777 58.2543L37.9083 54.374L37.1084 61.0623Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M49.2256 58.2543L54.9949 61.0623L54.195 54.374L49.2256 58.2543Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M54.9949 61.0623L49.2256 58.2543L49.6851 62.0154L49.634 63.5981L54.9949 61.0623Z",
    fill: "#D7C1B3",
    stroke: "#D7C1B3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1084 61.0623L42.4693 63.5981L42.4352 62.0154L42.8777 58.2543L37.1084 61.0623Z",
    fill: "#D7C1B3",
    stroke: "#D7C1B3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5707 51.8895L37.7715 50.4769L41.1582 48.9282L42.5707 51.8895Z",
    fill: "#233447",
    stroke: "#233447",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M49.5312 51.8895L50.9438 48.9282L54.3475 50.4769L49.5312 51.8895Z",
    fill: "#233447",
    stroke: "#233447",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1081 61.0624L37.9421 54.1528L32.6152 54.306L37.1081 61.0624Z",
    fill: "#CD6116",
    stroke: "#CD6116",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M54.1611 54.1528L54.995 61.0624L59.505 54.306L54.1611 54.1528Z",
    fill: "#CD6116",
    stroke: "#CD6116",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M58.2109 46.5455L48.6465 46.971L49.5315 51.8894L50.944 48.9281L54.3477 50.4768L58.2109 46.5455Z",
    fill: "#CD6116",
    stroke: "#CD6116",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M37.7718 50.4768L41.1585 48.9281L42.5711 51.8894L43.4561 46.971L33.8916 46.5455L37.7718 50.4768Z",
    fill: "#CD6116",
    stroke: "#CD6116",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8916 46.5455L37.908 54.3741L37.7718 50.4768L33.8916 46.5455Z",
    fill: "#E4751F",
    stroke: "#E4751F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M54.3485 50.4768L54.1953 54.3741L58.2117 46.5455L54.3485 50.4768Z",
    fill: "#E4751F",
    stroke: "#E4751F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M43.4563 46.9709L42.5713 51.8893L43.6945 57.6927L43.9328 50.0513L43.4563 46.9709Z",
    fill: "#E4751F",
    stroke: "#E4751F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M48.647 46.9709L48.1875 50.0343L48.4087 57.6927L49.532 51.8893L48.647 46.9709Z",
    fill: "#E4751F",
    stroke: "#E4751F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M49.5314 51.8894L48.4082 57.6927L49.2251 58.2543L54.1945 54.3741L54.3477 50.4768L49.5314 51.8894Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M37.7715 50.4768L37.9076 54.3741L42.8771 58.2543L43.694 57.6927L42.5707 51.8894L37.7715 50.4768Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M49.6341 63.5981L49.6851 62.0154L49.2597 61.641H42.8437L42.4352 62.0154L42.4693 63.5981L37.1084 61.0624L38.9804 62.5941L42.7926 65.2319H49.3107L53.1229 62.5941L54.9949 61.0624L49.6341 63.5981Z",
    fill: "#C0AD9E",
    stroke: "#C0AD9E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M49.226 58.2544L48.4091 57.6927H43.6949L42.878 58.2544L42.4355 62.0155L42.844 61.6411H49.26L49.6855 62.0155L49.226 58.2544Z",
    fill: "#161616",
    stroke: "#161616",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M66.3123 38.3936L67.7418 31.45L65.5975 25L49.2256 37.1513L55.5225 42.4781L64.4232 45.0819L66.3803 42.7844L65.5294 42.1718L66.8909 40.9294L65.8528 40.1125L67.2142 39.0744L66.3123 38.3936Z",
    fill: "#763D16",
    stroke: "#763D16",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3613 31.45L25.8079 38.3936L24.8889 39.0744L26.2504 40.1125L25.2123 40.9294L26.5737 42.1718L25.7228 42.7844L27.68 45.0819L36.5807 42.4781L42.8776 37.1513L26.5057 25L24.3613 31.45Z",
    fill: "#763D16",
    stroke: "#763D16",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M64.4235 45.0819L55.5228 42.478L58.2117 46.5455L54.1953 54.374L59.5051 54.306H67.4017L64.4235 45.0819Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5807 42.478L27.68 45.0819L24.7188 54.306H32.6154L37.9082 54.374L33.8918 46.5455L36.5807 42.478Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M48.6467 46.971L49.2254 37.1513L51.7952 30.1566H40.3076L42.8774 37.1513L43.4561 46.971L43.6773 50.0684L43.6943 57.6927H48.4085L48.4255 50.0684L48.6467 46.971Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetamask);
export default __webpack_public_path__ + "static/media/metamask.6dcf68e725c5334da8cd0b877db52a41.svg";
export { ForwardRef as ReactComponent };